const MAP_TYPES = Object.freeze({
  roadmap: 'roadmap',
  satellite: 'hybrid'
})

export default MAP_TYPES
